import { Pipe, PipeTransform } from '@angular/core';
import { Frequency } from '../models/frequency.model';
import { FoodWasteServiceDetail, FoodWasteServiceOptions } from '../models/service-details.model';
import { sortFrequency } from '../utils/sort-frequency';

@Pipe({
  name: 'adaptFoodWasteServiceOptions',
  standalone: true,
})
export class AdaptFoodWasteServiceOptionsPipe implements PipeTransform {
  public transform(value: { items: FoodWasteServiceDetail[] } | null): FoodWasteServiceOptions | null {
    if (value?.items?.length) {
      const alternativeSizes: { [key: number]: string } = {};
      const options = value.items as FoodWasteServiceDetail[];
      const optionsMatrix = new Map<string, FoodWasteServiceDetail>();
      options.forEach((item) => {
        // key in a format: <size>-<frequency>
        const key = item.containerSize + '-' + item.frequency;
        optionsMatrix.set(key, item);
      });
      const sizeOptions: Set<{ size: number; desc: string }> = new Set();
      options.forEach((item) => {
        sizeOptions.add({ size: item.containerSize, desc: item.foodWasteContainerDescription });
      });
      const sizes = [...sizeOptions].reduce((previousSizes, el) => {
        alternativeSizes[el.size] = el.desc;
        const filteredOptions = options.filter((item) => item.containerSize === el.size);
        const frequencyOptions: Set<Frequency> = new Set();
        filteredOptions.forEach((item) => {
          frequencyOptions.add(item.frequency);
        });
        return { ...previousSizes, [el.size]: sortFrequency([...frequencyOptions]) };
      }, {});

      return {
        items: options,
        sizes,
        seasonDurationOptions: [3, 4, 5, 6, 7, 8, 9],
        alternativeSizes,
        optionsMatrix,
      };
    }

    return null;
  }
}
